import { cn } from "@/lib/utils";
import { Warning2 } from "iconsax-react";
import { ElementType, FC, HTMLAttributes } from "react";

type EmptyStateProps = HTMLAttributes<HTMLDivElement> & {
  icon?: ElementType;
  message?: string;
};

const EmptyState: FC<EmptyStateProps> = ({ icon, message, ...props }) => {
  const Icon = icon || Warning2;

  return (
    <div
      className={cn(
        "flex max-w-xs flex-col items-center gap-3 text-[#8090A3]",
        props.className,
      )}
    >
      <Icon size={48} className="text-gray-300" />

      <div className="text-balance text-center text-sm">
        <div>{message}</div>
        {props.children}
      </div>
    </div>
  );
};

export default EmptyState;
